import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { CountdownTimer } from '../ui/CountdownTimer';
import { CHECKOUT_URL } from '../../utils/checkout';
import { rows, trustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-pilates" className="bg-paper py-10 sm:py-14" data-id="element-145" data-mp="3lhcyqlyk02h6">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-146" data-mp="3pigb2yhe7gdn">
        <SectionTag icon="🔥" tone="accent" data-id="element-147" data-mp="3uikqsmah872t">
          Oferta especial de lanzamiento
        </SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-148" data-mp="3c18km2b9euh">
          Asegura tu lugar antes de que termine la oferta
        </h2>

        <div className="mt-6" data-id="element-149" data-mp="206waogsidygu">
          <CountdownTimer data-id="element-150" data-mp="2534mbk7hz9j9" />
        </div>
        <p className="mt-3 text-sm font-semibold text-danger" data-id="element-151" data-mp="25466qfael8dn">
          🔴 El precio sube cuando termina el contador
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-152" data-mp="16k0689k77i8p">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border-2 border-gold/40 bg-white p-6 shadow-card-medium sm:p-7" data-id="element-153" data-mp="16ip5kim1uqlt">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-ink/60" data-id="element-154" data-mp="1u8b0uuzawloj">
            🏋️ Enciclopedia Pilates 360™
          </p>
          <p className="mt-1.5 text-xs text-ink/60" data-id="element-155" data-mp="1l8o26gxyhtz6">6 tomos + 6 bonos, listos para dar clase.</p>

          <div className="mt-4" data-id="element-156" data-mp="1ga3aj5wrsimc">
            <ScrollHintTable minWidth="320px" data-id="element-157" data-mp="1g8ryyjx326ko">
              <table className="w-full text-left text-sm" data-id="element-158" data-mp="1gc5wneusxrls">
                <thead data-id="element-159" data-mp="9uixflpx5g2s">
                  <tr className="border-b border-primary/10 bg-primary/5 text-xs uppercase tracking-wide text-primary" data-id="element-160" data-mp="9robfpr9bn79">
                    <th className="px-4 py-2 font-semibold" data-id="element-161" data-mp="6btr1coo3f7s">Item</th>
                    <th className="px-4 py-2 font-semibold" data-id="element-162" data-mp="6cmp7p9k8web">Valor</th>
                  </tr>
                </thead>
                <tbody data-id="element-163" data-mp="b8k925k18kvu">
                  {rows.map(row => <tr key={row.content} className="border-b border-primary/5" data-id="element-164" data-mp="3tfrlki73we1a">
                      <td className="px-4 py-2.5 text-ink/80" data-id="element-165" data-mp="1bpbppzhwqj5">{row.content}</td>
                      <td className="px-4 py-2.5 text-ink/60 line-through" data-id="element-166" data-mp="3jq80d5vx8839">{row.value}</td>
                    </tr>)}
                  <tr data-id="element-167" data-mp="3oi83163dlf3j">
                    <td className="px-4 py-2.5 font-semibold text-primary" data-id="element-168" data-mp="3ojjapgzxz6zx">Valor total</td>
                    <td className="px-4 py-2.5 font-semibold text-primary" data-id="element-169" data-mp="39udbht13tgs1">211€</td>
                  </tr>
                </tbody>
              </table>
            </ScrollHintTable>
          </div>

          <p className="mt-5 text-xs font-medium text-ink/60" data-id="element-170" data-mp="30snkupf1qlvb">Precio especial de lanzamiento:</p>
          <p className="font-heading text-5xl font-bold text-primary sm:text-6xl" data-id="element-171" data-mp="35q5ktqb35qr6">17,99€</p>
          <p className="mt-1 text-sm text-ink/50 line-through" data-id="element-172" data-mp="2m5ovczzr21j8">211€</p>

          <div className="mt-6" data-id="element-173" data-mp="2h6vjtd40wklp">
            <PrimaryButton href={CHECKOUT_URL} fullWidth data-id="element-174" data-mp="2h7wsxc1hax0s">
              Quiero la Enciclopedia Completa Ahora
            </PrimaryButton>
          </div>

          <p className="mt-3 text-center text-[11px] text-ink/60" data-id="element-175" data-mp="2r3qe1jt9jyu6">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía 7 días
          </p>
          <p className="mt-1 text-center text-[11px] text-ink/50" data-id="element-176" data-mp="351ofjomhk0s9">
            💱 El pago se procesará en la moneda de tu país
          </p>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-ink/60" data-id="element-177" data-mp="3eu3yop9iqveq">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-178" data-mp="39wubzhdikxul">
                <item.icon size={12} data-id="element-179" data-mp="3nvaib77gsmc7" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}